import { render, staticRenderFns } from "./page-scroll.vue?vue&type=template&id=a6d8ece2&scoped=true&"
import script from "./page-scroll.vue?vue&type=script&lang=js&"
export * from "./page-scroll.vue?vue&type=script&lang=js&"
import style0 from "./page-scroll.vue?vue&type=style&index=0&id=a6d8ece2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d8ece2",
  null
  
)

export default component.exports